import script from "./EventHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./EventHeader.vue?vue&type=script&setup=true&lang=js"

import "./EventHeader.vue?vue&type=style&index=0&id=3f13a3d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f13a3d9"]])

export default __exports__